export default __webpack_public_path__ + "static/media/slide5.2e29fe05.jpg";